import React, { Children, cloneElement, isValidElement,useContext,useEffect,useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { ToggleButton } from 'primereact/togglebutton';
import { Dialog } from 'primereact/dialog';
import { Menu } from 'primereact/menu';
import { Messages } from 'primereact/messages';
import { confirmPopup,ConfirmPopup } from 'primereact/confirmpopup'
import AppContext from '../../AppContext';
import { useTranslation } from 'react-i18next';


export function GenericGrid({parentId,loadRecords,reload,openPage,initEditRecord,recType,insertMultiple,
	initRecord,deleteRecord,deleteRecords,catDeleted,recordAdded,recordUpdated,updateRecord,editButton,openButton,
	form,formTemplate,progress,currentRowChanged,commandAction,editMenu,insertMenu,importMenu,exportMenu,filterMenu,deleteMenu,commandMenu,toolbarExtra,
	importAction,className,leftContents,rightContents,paginator,style,dialogHeader,commandMenuItems,children
	}){
    //props:
        //loadRecords(parentId)
        //insertMultiple(parentId,recs,recType)
        //insertRecord(parentId,rec,recType)
        //deleteRecord(rec)
        //deleteRecords(recs)
        //updateRecord(parentId,rec,recType)
        //recordAdded(rec)
        //recordDeleted(rec)
        //recordUpdated(rec)
        //recType
        //dialogHeader
        //form
		//formTemplate
		//updateForm
        //insertMenu,filterMenu,editMenu,exportMenu,importMenu
		//editButton,openButton
		//initRecord
		//initEditRecord
		//commandMenuItems
		//commandMenu
		//importAction
		//commandAction
		//selectionChanged(rec)
		//currentRowChanged(rec)
		//reload
		//leftContents,rightContents
	const {t}=useTranslation();
	const { clipType,setClipType } = useContext(AppContext);
	const { clip,setClip } = useContext(AppContext);

	const messages = useRef(null);
	const exportMenuRef = useRef(null);
	const importMenuRef = useRef(null);
	const editMenuRef = useRef(null);
	const gridMessage = useRef(null);
	const dataTable = useRef(null);
	const commandMenuRef = useRef(null);

	const [recs,setRecs] = useState([]);
	const [selectedRecs,setSelectedRecs] = useState([]);
	const [selectedRec,setSelectedRec] = useState({});
	const [formRec,setFormRec] = useState(null);
	const [displayForm,setDisplayForm] = useState(false);
	const [newRec,setNewRec] = useState(false);
	const [filterOn,setFilterOn] = useState(false);
	const [currentRow,setCurrentRow] = useState(null);

	useEffect(()=>{
		_loadRecs();
	},[]);
	useEffect(()=>{
		console.log('parentId:'+parentId+',reload:'+reload);
		if(reload)
			_loadRecs();
	},[parentId,reload]);

	const exportMenuItems=()=>{
		return [
			{
			   label:t('Export_as_CSV'),
			   icon:'pi pi-file',
			   command: ()=>{exportCSV()}
			},
			{
			   label:t('Export_as_XLSX'),
			   icon:'pi pi-file-excel'
			},
			{
			   label:t('Export_as_PDF'),
			   icon:'pi pi-file-pdf'
			}
		 ];
	}
	const importMenuItems=()=>{
		return [
		 ];
	}
	const editMenuItems=()=>{
		return [
			{
			   label:t('Copy_selected_rows'),
			   command: ()=>{copyToClipboard()}
			},
			{
			   label:t('Paste_rows'),
			   command: ()=>{pasteFromClipboard()}
			} 
		];
	}
	const getCommandMenuItems=()=>{
		if(commandMenuItems)
		{
			return commandMenuItems.map((item)=>{
				return {...item,command:()=>{commandActionCallback(item.action)}}
			});			
		}
		return [];
	}
	const _loadRecs=()=>{
		console.log('_loadRecs...'+parentId);
		if(parentId == null)
			return;		
		var ret = loadRecords(parentId);
		ret.then(r => { 
			setRecs(r);
			setSelectedRecs([]);
		});
	}
	const openForm=()=>{
		setDisplayForm(true);
	}
	const openThePage=(rec)=>{
		if(openPage != undefined)
			openPage(rec);
	}
	const editRecord=(rec)=>{
		var sr = rec;
		if(initEditRecord != undefined)
			sr = initEditRecord(rec);
		Promise.resolve(sr).then((val)=>{ //if sr is a promise
			setSelectedRec({...val});
			setNewRec(false);
			setDisplayForm(true);
		});
	}	
	const setFilter=(val)=>{
		setFilterOn(val);
	}
	const copyToClipboard=()=>{
		var _clip = [];
		for(var i=0; i<selectedRecs.length; i++)
		{
			let str = JSON.stringify(selectedRecs[i]);
			let _copy = JSON.parse(str);

			console.log(JSON.stringify(_copy));
			_clip.push(_copy);		
		}
		setClip(_clip);
		setClipType(recType);
	}
	const pasteFromClipboard=()=>{
		if(clipType != recType)
		{
			gridMessage.current.show({ severity: 'error', summary: t('error'), detail: t('@error.Not_suitable_for_this_table.') });
			return;
		}
		for(var i=0; i<clip.length; i++)
			console.log('clip['+i+'] = '+JSON.stringify(clip[i]));
		var ret = insertMultiple(parentId,clip,recType);
		ret.then(r => { _loadRecs() });
	}
	const insertRecord=()=>{
		console.log("insertrec called");
		var rec={};
		if(initRecord != undefined)
			rec = initRecord();
		setSelectedRec(rec);
		setNewRec(true);
		setFormRec(rec);
		openForm();
	}
	const deleteRecordCallback=(e)=>{
		if(selectedRecs.length == 0)
			return;
			confirmPopup({
				target:e.currentTarget,
				message: t('Are_you_sure_you_want_to_delete_selected_items'),
				header: t('Confirmation'),
				icon: 'pi pi-exclamation-triangle',
				accept: () => {
					let _cat = selectedRecs[0]; //TODO
					var ret = deleteRecord(_cat); 
					ret.then(()=>{
						let ind = findIndex(_cat);
						let _cats = recs;
						_cats.splice(ind,1);
						setRecs(_cats);
						setSelectedRecs([]);
						if(catDeleted)
							catDeleted(_cat);
					}).catch((error)=>{
						console.log('GenericGrid:deleteRec:error='+error);
					});
				}
			});			
	}
	const deleteRecordsCallback=(e)=>{
		if(selectedRecs.length == 0)
			return;
		confirmPopup({
			target:e.currentTarget,
			message: t('Are_you_sure_you_want_to_delete_selected_items'),
			header: t('Confirmation'),
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				let ids=[];
				for(var i=0; i<selectedRecs.length; i++)
					ids.push(selectedRecs[i].id);
				var ret = deleteRecords(ids); 
				ret.then(()=>{
					_loadRecs();
				}).catch((error)=>{
					console.log('GenericGrid:deleteRec:error='+error);
				});
			}
		});			
	}
	const hideForm=()=>{
		setDisplayForm(false);
	}	
	const findIndex=(rec)=>{
		for(var i=0; i<recs.length; i++)
		{
			if(recs[i].id == rec.id)
				return i;
		}
		return -1;
	}
	const formOK=()=>{
		console.log("formOK:"+parentId);
		if(newRec)
		{
			var ret = insertRecord(parentId,formRec,recType);		
			ret.then((r)=>{
				setDisplayForm(false);
				if(r!=undefined)
				{
					var nr=[...recs];
					nr.push(r);
					setRecs(nr);
					if(recordAdded)
						recordAdded(r);	
				}
				})
				.catch((error) => {
					console.log('GenericGrid:error='+error);
					console.log(error.response.data.message);
					if(error.response.data.error != undefined)
						showError(error.response.data.error);
					else
						showError(error.message);
				});		
		}
		else
		{
			var ret = updateRecord(formRec);		
			ret.then((r)=>{
				setDisplayForm(false);
				//this.state.cats.push(r);
				console.log('GenericGrid:formOK:'+JSON.stringify(r));
				if(r!=undefined)
				{
					let ind = findIndex(r);
					if(ind>=0)
					{
						let _cats = [...recs];
						_cats[ind] = r;
						setRecs(_cats);
					}
					if(recordUpdated)
						recordUpdated(r);
				}
				})
				.catch((error) => {
					console.log('GenericGrid:error='+error);
					console.log(error.response.data.message);
					if(error.response.data.error != undefined)
						showError(error.response.data.error);
					else
						showError(error.message);
				});		
		}
	}	
	const formClosed=()=>{
	}	
	const renderFooter=(name)=>{
        return (
            <div>
                <Button label={t("Cancel")} icon="pi pi-times" onClick={hideForm} className="p-button-text" />
                <Button label={t("Ok")} icon="pi pi-check" onClick={formOK} autoFocus />
            </div>
        );
    }	
	const formChanged=(rec)=>{
		setFormRec(rec);
		console.log("formChanged:" + JSON.stringify(rec));
	}
	const actionBodyTemplate=(rowData)=>{
		const btnCls = 'p-button-rounded p-button-sm p-button-text p-button-secondary mr-2 ';
		const editCls = btnCls + (editButton?'':'hidden');
		const openCls = btnCls + (openButton?'':'hidden');

        return (
            <div className='flex'>
                <Button icon="pi pi-pencil" tooltip={t('Edit')} className={editCls} onClick={() => editRecord(rowData)} />
                <Button icon="pi pi-link" tooltip={t('Open')} className={openCls} onClick={() => openThePage(rowData)} />
				{/*<Button icon="pi pi-trash" className="p-button-rounded p-button-sm p-button-text p-button-danger" onClick={() => this.confirmDeleteProduct(rowData)} />*/}
            </div>
        );
	}	
	const renderForm=()=>{
		if(form != undefined)
		{
			var DynamicForm = form;
			return <DynamicForm rec={selectedRec} progress={progress} parentId={parentId} onChange={formChanged} newRecord={newRec}/>;	
		}
		else if(formTemplate != undefined)
		{
			return formTemplate(parentId,selectedRec,newRec,formChanged);
		}
	}
	const showError = (err) => {
		messages.current.show({ severity: 'error', summary: '', detail: t('@error.'+err) });
	}	
	const rowSelected=(e)=>{
		console.log("onRowSelect:"+e.type+":"+JSON.stringify(e.data));
		/*if(e.type == 'row')
		{
			console.log('e.timestamp:'+e.originalEvent.timeStamp);
			this.setState({consumeRowSelect:e.originalEvent.timeStamp});
			this.setState({selectedRecs:[e.data]});
			this.setState({selectedRec:e.data});
			if(this.props.selectionChanged != undefined)
				this.props.selectionChanged(e.data);
		}*/
		setCurrentRow(e.data);
		if(currentRowChanged)
			currentRowChanged(e.data);
	}
	const selectionChanged=(e)=>{
		console.log('selectionChanged:'+e.originalEvent.timeStamp);
		if(e.originalEvent.target.tagName!=undefined && e.originalEvent.target.tagName.startsWith('TD'))
			return;
		setSelectedRecs(e.value);
	}
	const exportCSV=()=>{
		dataTable.current.exportCSV(false);
	}
	const commandActionCallback=(action)=>{
		console.log('command action:'+action);
		let ids=[];
		for(var i=0; i<selectedRecs.length; i++)
			ids.push(selectedRecs[i].id);

		commandAction(action,ids);
	}
	const rowClass = (data) => {
        return {
            'bg-blue-100': currentRow && (data.id === currentRow.id) 
        };
    };
	const btnCls = 'p-button-sm mr-2 ';
	const exportCls = btnCls + (exportMenu?'p-button-secondary':'hidden');
	const importCls = btnCls + (importMenu?'p-button-secondary':'hidden');
	const deleteCls = btnCls + (deleteMenu?'p-button-danger':'hidden');
	const insertCls = btnCls + (insertMenu?'p-button-secondary':'hidden');
	const commandCls = btnCls + (commandMenu?'p-button-secondary':'hidden');

	const filterCls = (filterMenu?'mr-2':'hidden');
	const editCls = btnCls + (editMenu?'p-button-secondary':'hidden');

	const getLeftContents=()=>{
		if(leftContents)
			return leftContents;
		return(
			<React.Fragment>
				<Button className={insertCls} label={t("New")} icon="pi pi-plus" onClick={insertRecord} />
				<Button className={commandCls} label={t("Command")} icon="pi pi-cog" disabled={selectedRecs.length == 0} onClick={(event) => commandMenuRef.current.toggle(event)}/>	
			</React.Fragment>
		)
	};

	const getRightContents=()=>{
		if(rightContents)
			return rightContents;

		return(
		<React.Fragment>
			<Menu model={exportMenuItems()} popup ref={exportMenuRef} />
			<Menu model={importMenuItems()} popup ref={importMenuRef} />
			<Menu model={editMenuItems()} popup ref={editMenuRef} />
			<Menu model={getCommandMenuItems()} popup ref={commandMenuRef}/>

			<Button className={editCls} label={t("Copy-paste")} icon="pi pi-copy" onClick={(event) => editMenuRef.current.toggle(event)}/>	
			<Button className={importCls} label={t("Import")} icon="pi pi-download" onClick={(event) => importAction(event)}/>	
			<Button className={exportCls} label={t("Export")} icon="pi pi-upload" onClick={(event) => exportMenuRef.current.toggle(event)}/>	
			<ToggleButton className={filterCls} onLabel={t("Filter")} offLabel={t("Filter")} checked={filterOn} icon="pi pi-trash" onChange={(e) => setFilter(e.value)} />
			<Button className={deleteCls} label={t("Delete")} icon="pi pi-trash" onClick={deleteRecordsCallback} disabled={selectedRecs.length == 0} />
			{toolbarExtra}
		</React.Fragment>
		)
	}		

	const getClassName=()=>{
		let clsnm='p-datatable-striped p-datatable-sm';
		if(className)
			clsnm=clsnm+' '+className;
		return clsnm;
	}
	return (
		<>
		<Messages ref={gridMessage}></Messages>
		<Toolbar left={getLeftContents()} right={getRightContents()} className='mb-2 mt-2'/>
		<DataTable ref={dataTable} value={recs} 
				className={getClassName()} size="small" selectionMode="single" 
				paginator={(paginator==false)?false:true} rows={20}
				selection={selectedRecs} onSelectionChange={e => selectionChanged(e)} dataKey="id" onRowClick={(e)=>rowSelected(e)}
				filterDisplay={filterOn?'row':'none'} showGridlines scrollable rowClassName={rowClass}
				scrollHeight="flex" style={style}
				>
			<Column selectionMode="multiple" headerStyle={{width: '3em'}} showFilterMenu={true}></Column>
			{Children.map(children, (child) => {
        		if (!isValidElement(child)) return child;
        		return cloneElement(child, { 
          			filter: filterOn 
        		});
      		})}			
			<Column body={actionBodyTemplate} style={{width:'10%'}}></Column>
		</DataTable>
		<Dialog header={dialogHeader} visible={displayForm} footer={renderFooter('displayBasic')} onHide={formClosed}>
			<Messages ref={messages}></Messages>
			{renderForm()}
		</Dialog>		
		<ConfirmPopup />	
		</>
	)
}
export default GenericGrid;
